import { KTIcon } from '../../../../../_metronic/helpers'

const ListSearchComponent = ({ searchClientName, setSearchClientName }) => {

    return (
        <div className='card-title'>
            <div className="row min-w-100">
                <div className="col">
                    <label className='form-label fs-6 fw-bold'>Pesquisar por cliente:</label>
                    <div className='d-flex align-items-center position-relative my-1'>
                        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                        <input
                            type='text'
                            data-kt-user-table-filter='searchClientName'
                            className='form-control form-control-solid ps-14'
                            placeholder='Pesquisar cliente'
                            value={searchClientName}
                            onChange={(e) => setSearchClientName(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export { ListSearchComponent }
